<template>
  <div :style="_style">
    <NumericTextBoxComponent
      ref="input"
      :value="modelValue"
      float-label-type="Always"
      :placeholder="placeholder"
      :format="format"
      :name="name"
      :step="step"
      :min="min"
      :max="max"
      locale="de"
      @change="$emit('update:modelValue', $event.value)"
    />
  </div>
</template>

<script setup lang="ts">
import {NumericTextBoxComponent} from "@syncfusion/ej2-vue-inputs";
import {ref, computed} from "vue";

interface Props {
  placeholder?: string,
  modelValue?: number,
  format?: string
  name?: string
  min?: number | string
  max?: number | string
  step?: number | string
  width?: string
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: undefined,
    format: undefined,
    name: undefined,
    min: undefined,
    max: undefined,
    step: undefined,
    width: "160px",
    placeholder: undefined
  }
)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(['update:modelValue'])
const input = ref<InstanceType<typeof NumericTextBoxComponent> | null>(null)

const _style = computed<string>(() => props.width ? "width: " + props.width : "")
const focus = () => {
  input.value?.focusIn();
}

defineExpose({
  focus
})

</script>

<style scoped>

</style>
